<template>
  <div v-if="isDemo && isLocked" class="fixed inset-0 z-[100] bg-slate-900 text-white flex flex-col items-center justify-center p-4">
    <div class="max-w-md w-full bg-slate-800 rounded-2xl shadow-2xl p-8 text-center border border-slate-700">
      <div class="inline-flex p-4 rounded-full bg-red-500/10 text-red-500 mb-4 ring-1 ring-red-500/20">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
      </div>

      <h2 class="text-3xl font-bold mb-2">Sesi Demo Berakhir</h2>
      <p class="text-slate-400 mb-8">
        Waktu akses demo 30 menit telah habis. Akses akan dibuka kembali dalam:
      </p>

      <div class="text-5xl font-mono font-bold text-blue-400 mb-8 tracking-wider bg-slate-900 py-6 rounded-xl border border-slate-700">
        {{ formatTime(remainingLockoutTime) }}
      </div>

      <div class="space-y-4">
        <p class="text-sm text-slate-400">
          Ingin akses tanpa batas? Gunakan akun Trial.
        </p>

        <div class="bg-blue-600/10 border border-blue-500/20 rounded-lg p-4 text-left">
          <p class="font-semibold text-blue-400 mb-1 flex items-center gap-2">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
            Hubungi Admin
          </p>
          <div class="text-sm space-y-1 text-slate-300 ml-6">
            <p>Email: alkara@alkaralintas.com</p>
            <p>WhatsApp: 0821-4742-2821</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDemoTimer } from '@/composables/useDemoTimer'

const { isDemo, isLocked, remainingLockoutTime, formatTime } = useDemoTimer()
</script>
